import { render, staticRenderFns } from "./BaseSubTitle.vue?vue&type=template&id=599eb716&scoped=true"
import script from "./BaseSubTitle.vue?vue&type=script&lang=js"
export * from "./BaseSubTitle.vue?vue&type=script&lang=js"
import style0 from "./BaseSubTitle.vue?vue&type=style&index=0&id=599eb716&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599eb716",
  null
  
)

export default component.exports